module.exports = __webpack_public_path__ + "static/media/stethoscope.e3bb2015.svg";